import * as React from "react";
const SvgCommentBank = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M2 2v20l4-4h16V2H2zm17 11-2.5-1.5L14 13V5h5v8z",
  fill: "currentColor"
}));
export default SvgCommentBank;